import React from 'react';
import './SiteFooter.css';

export function SiteFooter({ onNavigate, usuario }) {
  const currentYear = new Date().getFullYear();
  const whatsappUrl = 'https://wa.me/5567999359198?text=Ola%2C%20Fran!%20Quero%20agendar%20um%20horario.%20Pode%20me%20ajudar%3F';
  const instagramUrl = 'https://www.instagram.com/franmullerbeauty/';

  return (
    <footer className="site-footer">
      <div className="site-footer-container">
        <div className="site-footer-brand">
          <h3>✨ Fran Beauty</h3>
          <p>Realçando a sua beleza natural com sofisticação, cuidado e excelência em cada detalhe.</p>
          <span className="site-footer-location">✨ Espaço de Beleza & Estética</span>
        </div>

        <div className="site-footer-contact">
          <h4>Atendimento & Redes</h4>
          <div className="site-footer-social-links">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="site-social-btn site-social-whatsapp"
              title="Falar no WhatsApp"
            >
              <img src="/images/whatsapp-icon.png" alt="WhatsApp" />
              <span>(67) 99935-9198</span>
            </a>
            <a
              href={instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="site-social-btn site-social-instagram"
              title="Seguir no Instagram"
            >
              <img src="/images/instagram-icon.png" alt="Instagram" />
              <span>@franmullerbeauty</span>
            </a>
          </div>
        </div>

        <div className="site-footer-links">
          <h4>Links Rápidos</h4>
          <ul>
            <li>
              <a href="#sobre" onClick={(e) => { e.preventDefault(); onNavigate('site'); setTimeout(() => document.getElementById('sobre')?.scrollIntoView({ behavior: 'smooth' }), 100); }}>
                Um pouco sobre mim
              </a>
            </li>
            <li>
              <a href="#procedimentos" onClick={(e) => { e.preventDefault(); onNavigate('site'); setTimeout(() => document.getElementById('procedimentos')?.scrollIntoView({ behavior: 'smooth' }), 100); }}>
                Procedimentos & Preços
              </a>
            </li>
            <li>
              <button type="button" onClick={() => onNavigate('agendamento')}>
                Agendar Horário Online
              </button>
            </li>
            <li>
              <button type="button" className="site-footer-erp-link" onClick={() => onNavigate(usuario ? 'erp' : 'login')}>
                🔐 Área Restrita (Acesso ERP)
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="site-footer-bottom">
        <p>&copy; {currentYear} Fran Beauty — Espaço de Beleza. Todos os direitos reservados.</p>
      </div>
    </footer>
  );
}
